{
  "aboutFarmUserPermissions": "Acerca de los permisos de usuario de la granja",
  "canControlDevicesRemotely": {
    "displayName": "Utilice controles remotos",
    "extendedDescription": "Envíe comandos y solicitudes directas a los dispositivos de su granja, lo que le permitirá controlar sus interruptores y realizar otras acciones."
  },
  "canManageCustomTriggers": {
    "displayName": "Crear conexiones de dispositivos",
    "extendedDescription": "Crear, modificar y eliminar conexiones entre dispositivos, incluidas acciones que pueden activarse si un dispositivo cambia de un estado a otro."
  },
  "canManageDeviceConfiguration": {
    "displayName": "Cambiar configuraciones",
    "extendedDescription": "Crear, modificar y eliminar calibraciones de sensores del dispositivo y personalizaciones del dispositivo (el nombre para mostrar en la aplicación del dispositivo, por ejemplo)."
  },
  "canManageDeviceNotifications": {
    "displayName": "Crear notificaciones personalizadas",
    "extendedDescription": "Configure alertas para notificar a su tripulación cuando cambia el estado de un dispositivo."
  },
  "canManageDevicePermissions": {
    "displayName": "Compartir dispositivos",
    "extendedDescription": "Administre el acceso y el control de un dispositivo específico para otros usuarios dentro o fuera de su granja."
  },
  "canManageFarmAccount": {
    "displayName": "Cambiar los detalles de la cuenta de la granja",
    "extendedDescription": "Gestionar detalles relacionados con la administración del negocio (por ejemplo, cambiar la dirección registrada de la granja)."
  },
  "canManageFields": {
    "displayName": "Administrar campos",
    "extendedDescription": "Cree, edite y elimine los registros de campos de su finca y de riego asociados."
  },
  "canManageJoinCodes": {
    "displayName": "Administrar códigos de ingreso a la granja",
    "extendedDescription": "Otorgue a los usuarios acceso y permisos a su cuenta de granja."
  },
  "canManageSchedules": {
    "displayName": "Administrar programaciones de dispositivos",
    "extendedDescription": "Cree y edite acciones únicas y recurrentes para dispositivos."
  },
  "canManageUserPermission": {
    "displayName": "Editar otros permisos de usuario",
    "extendedDescription": "Otorgar o revocar permisos a nivel de granja a otros usuarios de su granja."
  },
  "devicePermissionsDescription": "Permitir al usuario realizar acciones en los dispositivos de la granja.",
  "devicePermissionsTitle": "Permisos del dispositivo",
  "farmPermissionsDescription": "Permitir al usuario administrar aspectos de la cuenta de la granja.",
  "farmPermissionsTitle": "Permisos de granja",
  "farmUserPermissionsAllowYouTo": "Los permisos de granja y de dispositivo le permiten realizar determinadas acciones dentro de FarmHQ. Estos permisos pueden ser otorgados o revocados por un administrador de granja.",
  "farmUserPermissionsHelpSummary": "Los permisos de usuario de la granja determinan qué acciones puede realizar un usuario determinado. Esto permite que el administrador de la granja proteja sus dispositivos contra el uso indebido por parte de otros (intencionadamente o no).\n\nTambién puede liberar al administrador de la granja y a otros trabajadores de la misma de la preocupación de realizar acciones accidentales que puedan tener consecuencias no deseadas.",
  "farmUserPermissionsTitle": "Permisos de usuario de la granja",
  "permissionDenied": "Permiso denegado",
  "thisPermission": "Este permiso:",
  "youDoNotHavePermission": "No tienes permiso para realizar esta acción. Ponte en contacto con un administrador de tu cuenta para obtener acceso.",
  "youDoNotHavePermissionToAccessThisResource": "No tienes permiso para acceder a este recurso. Ponte en contacto con un administrador de tu cuenta para obtener acceso."
}
